var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    viewBox: "0 0 8 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00403 1.10636C0.346482 0.51287 1.3876 -0.426818 2.04514 0.216126L6.86715 4.51891C7.14113 4.7662 7.14113 5.21131 6.86715 5.4586L2.04514 9.81084C1.3876 10.4043 0.346482 9.46464 1.00403 8.87115L5.27808 5.01348L1.00403 1.10636Z",
    fill: "#142952"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrowRight);
export default __webpack_public_path__ + "static/media/VectorArrowRight.ce4c8664aa40545b14063543aae2c35c.svg";
export { ForwardRef as ReactComponent };